import * as React from "react"
import { useComputed } from "@preact/signals-react"
import { Box, Grid } from "@mui/material"
import { ImageSeeker } from "@ui-seeker/core"

import { HierarchicalTextBlock } from "@components"
import { AvailableButton } from "../../@components"
import { useAdminSkuModal } from "../../@hooks"
import { adminSkuModalData } from "../../@signals"


export default function AdminSkuModalSkuInfo() {
    const imageURL = useComputed(() => adminSkuModalData.value.imageURL)
    const category = useComputed(() => adminSkuModalData.value.category)
    const brand = useComputed(() => adminSkuModalData.value.brand)
    const ean = useComputed(() => adminSkuModalData.value.ean)

    return <Grid container spacing={1}>
        <Grid item xs={4}>
            <Box>
                <ImageSeeker
                    src={imageURL.value || ""}
                    sx={{
                        height: 150,
                        weight: 150,
                        objectFit: "contain",
                        objectPosition: "center"
                    }}
                />
            </Box>
        </Grid>
        <Grid item xs={8}>
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                gap={1}
            >
                <HierarchicalTextBlock
                    supertitle="Category: "
                    supertitleValue={category.value}
                    title="Brand: "
                    titleValue={brand.value}
                    subtitle="EAN: "
                    subtitleValue={ean.value}
                />
                <Box display="flex" gap={2}>
                    <AdminSkuModalAvailable label="Pricing" availableType="availablePricing" />
                    <AdminSkuModalAvailable label="Marketplaces" availableType="availableMarketplaces" />
                </Box>
            </Box>
        </Grid>
    </Grid>
}

const AdminSkuModalAvailable = ({ availableType, label }) => {
    const { localValue, handleChange } = useAdminSkuModal(availableType)

    return <AvailableButton
        label={label}
        status={localValue}
        onClick={() => handleChange(!localValue)}
    />
}